// extracted by mini-css-extract-plugin
export var body = "_37-1";
export var bodyPadded = "_37-2";
export var chevron = "_37-4";
export var chevronOpen = "_37-5";
export var header = "_37-0";
export var icon = "_37-3";